import { NgModule } from '@angular/core';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { CircleProgressComponent } from './circle-progress.component';

@NgModule({
  declarations: [CircleProgressComponent],
  imports: [NgCircleProgressModule.forRoot({})],
  exports: [CircleProgressComponent],
})
export class CircleProgressComponentModule {}
